export default class LinkList {
    private container: HTMLElement | null;
    private body: HTMLElement | null;
    private template: HTMLElement | null;
    private btnAdd: HTMLElement | null;
    private counter = 0;

    constructor(container: HTMLElement) {
        this.container = container;
        this.body = this.container?.querySelector('.js-linklist-body') || null;
        this.template = this.container?.querySelector('.js-linklist-template').cloneNode(true) as HTMLElement || null;
        this.template = this.template.cloneNode(true) as HTMLElement;

        // nur ein Button zum hinzu fügen vorhanden
        this.btnAdd = this.container?.querySelector('.js-linklist-add') || null;

        this.init();
    }

    private init(): void {
        this.btnAdd?.addEventListener('click', () => this.addNewEntry());

        this.body.querySelectorAll('.js-linklist-delete').forEach((btn) => {
                btn.addEventListener('click', () => this.deleteEntry(btn as HTMLElement));
            });

        this.initIcons();
    }

    private addNewEntry(): void {
        if (!this.template || !this.container) return;

        const newEntry = this.template.cloneNode(true) as HTMLElement;
        const inputs = newEntry.querySelectorAll('input');
        inputs.forEach((input) => {
            input.value = '';
        });

        const btnDelete = newEntry.querySelector('.js-linklist-delete');
        btnDelete?.classList.remove('d-none');
        btnDelete?.addEventListener('click', () => this.deleteEntry(btnDelete as HTMLElement));

        const lastTemplate = this.body.querySelectorAll('.js-linklist-template')[this.body.querySelectorAll('.js-linklist-template').length - 1];
        const lastTemplateNumber = (lastTemplate.querySelector('input') as HTMLInputElement)?.name.match(/\d+$/)?.[0];
        this.counter = parseInt(lastTemplateNumber) + 1;

        newEntry.querySelectorAll('input, select').forEach((input: HTMLInputElement) => {
            input.name = input.name.replace(/\d+$/, this.counter.toString());
            input.dataset.name = input.name;
        });

        this.body.insertAdjacentElement('beforeend', newEntry);
        this.initIcons(newEntry);
    }

    private deleteEntry(btn: HTMLElement): void {
        if(this.body.querySelectorAll('.js-linklist-template').length > 1) {
            btn.closest('.row')?.remove();
        }
    }

    private initIcons(newEntry: HTMLElement = null): void {
        if (newEntry) {
            newEntry.querySelectorAll('.icons.dropdown').forEach((dropdown) => {
                $(dropdown).selectmenu().data('ui-selectmenu')._renderItem = function (ul, item) {
                    var li = $('<li class="icon icon-' + item.value + '">');
                    return li.appendTo(ul);
                };
                newEntry.querySelectorAll('.ui-selectmenu-button.ui-widget.ui-state-default.ui-corner-all').forEach((widget: HTMLElement, index) => {
                    if (index > 0) {
                        widget.remove();
                    }
                });
            });
        } else {
            $('.icons.dropdown').each(function () {
                // stylen des dropdowns
                $(this).selectmenu().data('ui-selectmenu')._renderItem = function (ul, item) {
                    var li = $('<li class="icon icon-' + item.value + '">');
                    return li.appendTo(ul);
                };
            });
        }
    }
}
